import { render, staticRenderFns } from "./fenqiPayDetail.vue?vue&type=template&id=ea06274e&scoped=true&"
import script from "./fenqiPayDetail.vue?vue&type=script&lang=js&"
export * from "./fenqiPayDetail.vue?vue&type=script&lang=js&"
import style0 from "./fenqiPayDetail.vue?vue&type=style&index=0&id=ea06274e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea06274e",
  null
  
)

export default component.exports